module.exports = __webpack_public_path__ + "img/d165991.jpg";